import { getChainById, getTokens, getTokensByChainId } from "common";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { zeroAddress } from "viem";
const defaultVotingTokens = Object.entries(getTokens()).reduce((acc, _ref) => {
  let [chainId, tokens] = _ref;
  const votingToken = tokens.find(token => token.canVote);
  if (votingToken) {
    acc[Number(chainId)] = votingToken;
  }
  return acc;
}, {});
function isSameProject(a, b) {
  return a.grantApplicationId.toLowerCase() === b.grantApplicationId.toLowerCase() && a.chainId === b.chainId && a.roundId === b.roundId;
}
function updateOrInsertCartProject(currentProjects, newProject) {
  const initialAcc = {
    projects: [],
    hasUpdatedProject: false
  };
  const result = currentProjects.reduce((acc, project) => {
    if (isSameProject(project, newProject)) {
      return {
        projects: [...acc.projects, newProject],
        hasUpdatedProject: true
      };
    } else {
      return {
        ...acc,
        projects: [...acc.projects, project]
      };
    }
  }, initialAcc);
  return result.hasUpdatedProject ? result.projects : [...currentProjects, newProject];
}
export const useCartStorage = create()(persist((set, get) => ({
  projects: [],
  setCart: projects => {
    set({
      projects
    });
  },
  add: newProject => {
    const currentProjects = get().projects;
    set({
      projects: updateOrInsertCartProject(currentProjects, newProject)
    });
  },
  /** @param grantApplicationId - ${roundAddress}-${applicationId} */
  remove: projectToRemove => {
    set({
      projects: get().projects.filter(proj => proj.grantApplicationId !== projectToRemove.grantApplicationId || proj.chainId !== projectToRemove.chainId || proj.roundId !== projectToRemove.roundId)
    });
  },
  clear: () => {
    set({
      projects: []
    });
  },
  updateDonationsForChain: (chainId, amount) => {
    const newState = get().projects.map(project => ({
      ...project,
      amount: project.chainId === chainId ? amount : project.amount
    }));
    set({
      projects: newState
    });
  },
  updateDonationAmount: (chainId, roundId, grantApplicationId, amount) => {
    if (amount.includes("-")) {
      return;
    }
    const projectIndex = get().projects.findIndex(donation => donation.chainId === chainId && donation.roundId === roundId && donation.grantApplicationId === grantApplicationId);
    if (projectIndex !== -1) {
      const newState = [...get().projects];
      newState[projectIndex].amount = amount;
      set({
        projects: newState
      });
    }
  },
  chainToVotingToken: defaultVotingTokens,
  getVotingTokenForChain: chainId => {
    const tokenFromStore = get().chainToVotingToken[chainId];
    if (!tokenFromStore) {
      const defaultToken = getTokensByChainId(chainId).filter(token => token.canVote && token.address === zeroAddress)[0];
      console.log("no token for chain", chainId, " defaulting to ", defaultToken, " and setting it as the default token for that chain");
      get().setVotingTokenForChain(chainId, defaultToken);
      return defaultToken;
    } else {
      return tokenFromStore;
    }
  },
  setVotingTokenForChain: (chainId, payoutToken) => {
    if (!getChainById(chainId)) {
      if (process.env.NODE_ENV !== "test") {
        console.warn("Tried setting payoutToken", payoutToken, "for chain", chainId, ", but chain", chainId, " doesn't exist");
      }
      return;
    }
    set({
      chainToVotingToken: {
        ...get().chainToVotingToken,
        [chainId]: payoutToken
      }
    });
  }
}), {
  name: "cart-storage",
  version: 3
}));